export default __webpack_public_path__ + "static/media/pride2022.f73b4a9b.jpg";